const playWhenVisible = function(item, slider){
	const Obs = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(!entry.isIntersecting){
				slider.pause();
			}
			else {
				slider.play();
			}
		});
	}, {
		root: null,
		rootMargin: '0px',
		threshold: 0.3
	});
	Obs.observe($(item).closest('.tns-outer')[0]);
};

$(document).ready(() => {

	const setVh = () =>{
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}
	setVh();

	let resizeTimeout;

	const resize = () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			setVh();
		}, 150);
	}

	window.addEventListener('resize', resize);
	window.addEventListener('orientationchange', resize);
	window.addEventListener('scroll', resize);


	let lastHeight = window.innerHeight;
	const monitorHeight = () => {
		const currentHeight = window.innerHeight;
		if (currentHeight !== lastHeight) {
			lastHeight = currentHeight;
			setVh();
		}
		requestAnimationFrame(monitorHeight);
	};
	monitorHeight();


	const $body = $('body');

	////replaceSchwaWithApostrophe();

	$("[data-mask]").each(function () {
		const type = $(this).data("mask");
		switch (type) {
			case "phone":
				$(this).inputmask({
					showMaskOnHover: false,
					mask: "+\\9\\94   * ### ## ##",
					/*oncomplete: function () {
						const p = $(this).parent();
						if (!p.find("i.success").length)
							$("<i/>").addClass("success").appendTo(p);
						p.addClass("success");
					},
					onincomplete: function () {
						$(this).parent().removeClass("success");
					},*/
					onBeforeMask:function(value){
						value = value.replace(new RegExp(/[^0-9]/,'gi'),'');
						if(value.length === 12 && value.substring(0,3)==='994')value = value.substring(3);
						return value;
					},
					definitions: {
						"#": {
							validator: "[0-9]",
							cardinality: 1,
							casing: "lower",
						},
						"*": {
							validator: "(10|50|51|55|60|70|77|99)",
							cardinality: 2,
							prevalidator: [{validator: "[15679]", cardinality: 1}],
						},
					},
				});
				break;
			case "numeric":
			case "integer":
				$(this).inputmask(type, {rightAlign: false});
				break;
			case "cur":
				$(this).inputmask({
					suffix: " " + $(this).data("currency"),
					groupSeparator: ",",
					alias: "numeric",
					placeholder: "0",
					autoGroup: !0,
					digits: 2,
					digitsOptional: !1,
					clearMaskOnLostFocus: !1,
					rightAlign: false,
				});
				break;
		}
	});

	$("[data-match-height]").each(function () {
		$(this).find($(this).attr("data-match-height")).matchHeight();
	});

	if ($(".programs .images").length) {
		$(".programs .images .slider").each(function(){
			const slider = tns({
				container: this,
				gutter: 20,
				items: 1.3,
				controlsText: ["", ""],
				nav: false,
				loop: true,
				edgePadding: 0,
				autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
				responsive: {
					500: {
						items: 2,
						gutter: 40,
					},
					768: {
						items: 1,
					},
					900: {
						items: 2,
					},
					1180: {
						items: 2.5
					}
				}
			});
			playWhenVisible(this, slider);
		});
	}
	if ($(".destination-info .images").length) {
		$(".destination-info .images .slider").each(function(){
			const slider = tns({
				container: this,
				gutter: 40,
				items: 1,
				controls:false,
				loop: false,
				autoplay: true,
				autoplayButtonOutput:false,
				autoplayHoverPause:true,
			});
			playWhenVisible(this, slider);
		});
	}
	if ($(".home-slider .images").length) {
		const pagination = (info) => {
			const text = `${info.displayIndex}/${info.slideCount}`;
			$(".home-slider .images .st label").text(text);
			const p = (info.displayIndex / info.slideCount * 100).toFixed(2);
			$(".home-slider .images .st i").css('width', `${p}%`);
		};
		const homeSlider = tns({
			container: ".home-slider .images .slider",
			items: 1,
			controls:false,
			nav: false,
			loop: true,
			autoplay: true,
			autoplayButtonOutput:false,
			autoplayHoverPause:true,
			onInit:(info)=>{ pagination(info); }
		});
		homeSlider.events.on('indexChanged', (info)=>{
			pagination(info);
		});
	}
	if ($(".gallery-page .gallery").length && !$.isMobile) {
		$(".gallery-page .slider").each(function(){
			const $this = $(this);

			let ratio = 0;
			const gallerySlider = tns({
				container: this,
				gutter: 38,
				items: 1,
				controls:false,
				loop: false,
				autoplay: false,
				autoplayButtonOutput:false,
				mouseDrag:true,
				autoWidth:true,
				responsive: {
					768: {
						items: 3.5
					},
				},
				onInit:(info)=>{
					const gw = $(".gallery-page .gallery").width();
					const sw = $(".gallery-page .scroller").width();
					const totalWidth = Array.from(info.slideItems).map(slide => slide.offsetWidth).reduce((sum, width) => sum + width, 0);
					ratio = sw / gw;
					const w = totalWidth * ratio;
					$(".gallery-page .scroller i").width(w);
				}
			});

			const scrollbar = $this.closest('.gallery').find('.scroller')[0];

			let scrollTimer = null;
			const clearScrollTimer = () =>{
				console.log('clearScrollTimer');
				clearTimeout(scrollTimer);
				scrollTimer = null;
				if(moveTimer !== null)clearMoveTimer();
			}
			let moveTimer = null;
			const clearMoveTimer = () =>{
				console.log('clearMoveTimer');
				clearTimeout(moveTimer);
				moveTimer = null;
				if(scrollTimer !== null)clearScrollTimer();
			}
			let isScrolling = false;
			let isMoving = false;
			const reset = ()=>{
				setTimeout(()=>{
					console.log('reset');
					isScrolling = false;
					isMoving = false;
				},100);
			};
			const scroll = ()=>{
				isScrolling = true;

				const scrollLeft = scrollbar.scrollLeft / ratio;
				const slideWidths = Array.from(gallerySlider.getInfo().slideItems).map(slide => slide.offsetWidth);
				let currentPosition = 0;
				let slideIndex = 0;
				while (currentPosition + slideWidths[slideIndex] <= scrollLeft) {
					currentPosition += slideWidths[slideIndex];
					slideIndex++;
				}
				gallerySlider.goTo(slideIndex);
				console.log('goTo', slideIndex, scrollLeft, scrollbar.scrollLeft);
				clearScrollTimer();
				reset();
			};

			scrollbar.addEventListener('scroll', (event) => {
				console.log('scroll', scrollTimer);
				if(scrollTimer !== null)clearScrollTimer();
				if(isScrolling || isMoving)return;
				console.log('scrollTimer seted');
				scrollTimer = setTimeout(()=>scroll(), 50);
			});

			const indexChanged = (info)=>{
				isMoving = true;
				console.log('indexChangedTimer', info.index);
				const slideWidths = Array.from(info.slideItems).map(slide => slide.offsetWidth);
				let currentPosition = 0;
				for (let i = 0; i < info.index; i++) {
					currentPosition += slideWidths[i];
				}
				scrollbar.scrollLeft = currentPosition * ratio ;
				clearMoveTimer();
				reset();
			}

			gallerySlider.events.on('indexChanged', (info) => {
				console.log('indexChanged', moveTimer , info);
				if(moveTimer !== null)clearMoveTimer();
				if(isScrolling || isMoving)return;
				console.log('moveTimer seted');
				moveTimer = setTimeout(()=>indexChanged(info), 50);
			});

		});
	}
	Fancybox.bind("[data-fancybox]");

	$('.toggle-mobile-menu').click(()=>{
		$('body').toggleClass('navi-active');
	});
	$(document).on("mobileOn", ()=>{
		if($('#header .navi .footer').length === 0){
			const footer = $('<div class="footer" />').appendTo('#header .navi');
			$('#header .top .rs').clone().appendTo(footer);
			$('#header .top .ls').clone().appendTo(footer);
		}
	});

	$(document).on("mobileOff", ()=>{
		$('body.navi-active').removeClass('navi-active');
	});

	if(['localhost:3000','kalbajar.pages.dev','kalbajar.cdn.az'].includes(window.location.host)){
		const path = window.location.pathname;
		const link = $('#header .navi a[href*="'+path+'"]');
		if(link.length > 0 && path.length > 2)link.addClass('active');
	}

	const navi = $('#header .navi');
	const sticky = navi[0].offsetTop;
	window.addEventListener('scroll', function() {
		if (window.scrollY > sticky) {
			navi.addClass('sticky');
		} else {
			navi.removeClass('sticky');
		}
	});

	const media = window.matchMedia("(max-width: 991px)");
	mobileSupport(media);
	media.addEventListener('change', mobileSupport);
});

$.isMobile = false;
const mobileSupport = (media) => {
	if (media.matches) {
		$.isMobile = true;

		$(document).trigger("mobileOn");
	} else {
		$.isMobile = false;

		$(document).trigger("mobileOff");
	}
};

function replaceSchwaWithApostrophe() {
	function hasBerlingskeSerifFont(element) {
		const computedStyle = window.getComputedStyle(element);
		const fontFamily = computedStyle.fontFamily.toLowerCase();
		return fontFamily.includes('berlingske serif') || fontFamily.includes('berlingske-serif');
	}

	function getAllTextNodesWithFont(element) {
		let textNodes = [];

		if (element.nodeType === Node.TEXT_NODE) {
			const parentElement = element.parentElement;
			if (parentElement && hasBerlingskeSerifFont(parentElement)) {
				textNodes.push(element);
			}
		} else {
			for (let child of element.childNodes) {
				textNodes = textNodes.concat(getAllTextNodesWithFont(child));
			}
		}

		return textNodes;
	}

	const textNodes = getAllTextNodesWithFont(document.body);

	textNodes.forEach(node => {
		if (node.textContent.includes('ə')) {
			node.textContent = node.textContent
				.replace(/ə/g, "'");
		}
	});

	const inputs = document.querySelectorAll('input[type="text"], textarea');
	inputs.forEach(input => {
		if (hasBerlingskeSerifFont(input) && input.value.includes('ə')) {
			input.value = input.value
				.replace(/ə/g, "'");
		}
	});
}